import { PRECALCULATED_CSV_DATA } from 'constants/actionTypes';

const initialState = '';

export default (state = initialState, action) => {
  switch (action.type) {
    case PRECALCULATED_CSV_DATA:
      return action.csvDataString;
    default:
      return state;
  }
};
